var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioBtnCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.75,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#C1AF82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.3125C11.7437 13.3125 13.5625 11.4937 13.5625 9.25C13.5625 7.00634 11.7437 5.1875 9.5 5.1875C7.25634 5.1875 5.4375 7.00634 5.4375 9.25C5.4375 11.4937 7.25634 13.3125 9.5 13.3125Z",
    fill: "#101010"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.75,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioBtnCheck);
export default __webpack_public_path__ + "static/media/radio-btn-check.304169c88f57b2f2362d8cfe7f06d758.svg";
export { ForwardRef as ReactComponent };